<template>
  <div class="travels">
    <div class="map-wrapper">
      <div class="over-map-content"></div>
      <travels-map
        :events="events"
        :travel-steps="travelStepsAtIndex"
        @open-event-dialog="openEventDialog"
      ></travels-map>
    </div>
    <controls
      :events="events"
      :travel-index.sync="travelIndex"
      :travel-steps="travelSteps"
      @open-config-dialog="openConfigDialog"
    ></controls>
    <config-dialog
      ref="configDialog"
      :vehicles="vehicles"
      :start-date.sync="startDate"
      :finish-date.sync="finishDate"
      :selected-vehicle.sync="selectedVehicle"
    ></config-dialog>
    <event-dialog ref="eventDialog"/>
  </div>
</template>

<script>
import Map from '@/components/Travels/Map'
import Controls from '@/components/Travels/Controls'
import EventDialog from '@/components/EventDialog'
import ConfigDialog from '@/components/Travels/ConfigDialog'

export default {
  name: 'travels',
  data: function () {
    return {
      selectedVehicle: null,
      startDate: null,
      finishDate: null,
      travelIndex: 0,
      eventsDialogData: null
    }
  },
  computed: {
    events: function () {
      return this.$store.getters['Travels/fixedEvents']
    },
    vehicles: function () {
      return this.$store.state.Travels.vehicles
    },
    travelSteps: function () {
      return this.events.map(event => {
        return {
          latLng: {
            lat: event.data.gps.latitude,
            lng: event.data.gps.longitude
          },
          eventId: event._id
        }
      })
    },
    travelStepsAtIndex: function () {
      return this.travelSteps.slice(0, this.travelIndex)
    }
  },
  watch: {
    selectedVehicle: function () {
      this.fetchEvents()
    },
    startDate: function () {
      this.fetchEvents()
    },
    finishDate: function () {
      this.fetchEvents()
    }
  },
  created: function () {
    this.$store.dispatch('Travels/fetchVehicles')
  },
  components: {
    'travels-map': Map,
    'controls': Controls,
    'config-dialog': ConfigDialog,
    'event-dialog': EventDialog
  },
  methods: {
    fetchEvents: async function () {
      if (!this.selectedVehicle || !this.startDate || !this.finishDate) {
        return false
      }
      await this.$store.dispatch('Travels/fetchEvents', {
        vehicleId: this.selectedVehicle._id,
        startDate: this.startDate,
        finishDate: this.finishDate
      })
    },
    openEventDialog: function ({ eventId }) {
      this.$refs.eventDialog.open({ eventId })
    },
    openConfigDialog: function () {
      const configDialog = this.$refs.configDialog
      configDialog.open()
    }
  }
}
</script>

<style lang="sass" scoped>
.travels
  height: 100%
  margin: 0
  padding: 0
.map-wrapper
  position: relative
.over-map-content
  position: absolute
  z-index: 1
</style>




// WEBPACK FOOTER //
// src/views/Travels.vue